export default {
      id: "LWS-shapedLine-usage",
      viewBox: "0 0 150 32",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-shapedLine",
      toString: function () {
        return this.url;
      }
    }